














import Vue, { PropType } from 'vue';

import { denseText } from '@/helpers/denseText';

export default Vue.extend({
  name: 'AtomTypography',
  props: {
    tag: {
      type: String,
      default: 'p',
    },
    variant: {
      type: String as PropType<
        'heading1' | 'heading2' | 'heading3' | 'body1' | 'body2' | 'body3'
      >,
      default: 'body2',
    },
    pre: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formattedText: this.dense ? denseText(this.text) : this.text,
    };
  },
  created() {
    if (this.dense) {
      this.$watch(
        () => this.text,
        () => {
          this.formattedText = denseText(this.text);
        },
      );
    }
  },
});
